import { Button } from '../../../../../components/button';
import { PlusOutlined } from '@ant-design/icons';
import style from './style.module.scss';

export function EmptyAvailabilities({ onAdd }: { onAdd: () => void }) {
    return (
        <div className={style.empty_state_content}>
            <label
                className={`${style.empty_state_label} footnote_description`}
            >
                No availability schedules configured yet
            </label>
            <Button variant="secondary" icon={<PlusOutlined />} onClick={onAdd}>
                Add availability
            </Button>
        </div>
    );
}
